import React from 'react';

export const AppLauncherIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Outlined/app_launcher">
        <path
          id="Union"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4 4H8V8H4V4ZM8 10H4V14H8V10ZM8 16H4V20H8V16ZM10 10H14V14H10V10ZM14 16H10V20H14V16ZM16 10H20V14H16V10ZM20 16H16V20H20V16ZM14 4H10V8H14V4ZM16 4H20V8H16V4Z"
          fill="#0B41CD"
        />
      </g>
    </svg>
  );
};
